<button nz-button nzType="default">
  <span nz-icon [nzType]="icon"></span>
  <ng-container [ngTemplateOutlet]="renderer" [ngTemplateOutletContext]="{ $implicit: label }"></ng-container>
</button>


<ng-template #renderer let-value>
  <ng-container *ngIf="value">
    <ng-container *ngIf="isString(value); else valueTpl">{{ value }}</ng-container>
    <ng-template #valueTpl>
      <ng-container [ngTemplateOutlet]="$TemplateRef(value)"></ng-container>
    </ng-template>
  </ng-container>
</ng-template>
